<template src='./locations.html'></template>

<script>
import {API_URL} from '@/main'
import axios from "axios"
import router from '@/router/index.js'

export default {
  name: "Locations",
  data() {
    return {
      current_id: null,
      currentPage: 1,
      form_data: {
        id: null,
        location: "",
        nation_id: null,
        acronym: '',
      },
      nations_list: [],
      locations: [],
      perPage: 10,
      showAlert: false,
      showModal: false,      
      total_rows: 0,
    }
  },
  watch: {
    currentPage: {
      handler(newPage, oldPage) {
    
        console.log(`Page changed from ${oldPage} to ${newPage}`)
      }
    }
  },   
  computed: {
    paginatedLocations() {

      return this.locations
    },
    totalRows() {this.totalRows = this.totalRows / this.perPage

      return this.locations.length
    }
  },  
  mounted() {

    this.loadNationsList()
    this.loadLocationsList()
  },
  methods: {
    cancelLocation() {

      this.current_id = null
      this.form_data = {}
    },
    async deleteRecord(id) {

      this.id2Delete = id
      this.showModal = true
    },    
    editRow(location) {

      console.debug(location.nation) /**/
      if(!location || !location.nation) {

        console.error("nation is not defined in the selected row")
        return
      }

      const selectedNation = this.nations_list.find(
      
        (nation) => nation.text === location.nation
      )

      if(!selectedNation) {
   
        console.error("Could not find nation in nations_list:", location.nation)
        return
      }

      this.current_id = location.id
      this.form_data.id = location.id
      this.form_data.location = location.place
      this.form_data.nation_id = selectedNation.value
      this.form_data.acronym = location.acronym
    },    
    async handleDelete() {

      try {
      
        const url = API_URL + "geographic/LocationsDetail/" + this.id2Delete + "/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.delete(url, {headers})
        this.showModal = false
        this.current_id = null
        await this.loadLocationsList()
      } 
      catch (error) {
      
        console.debug("handleDelete() error", error)
        if(error.response.status == 500) {
          
          this.alertMsg = "Attenzione! La località risulta essere utilizzata da almeno una riga di listino. Per rimuoverlo di devono prima rimuovere tutte le righe di listino che utilizzano questa località"
          this.showAlert = true
        }
      }
    },
    handlePageChange(page) {

      this.currentPage = page
      this.$nextTick(() => {
        
        this.loadLocationsList()
      })
    },    
    async insertLocation() {

      const url = API_URL+"geographic/LocationsDetail/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.post(url, this.form_data, {headers})
      this.cancelLocation()
      this.loadLocationsList()
    },
    async loadNationsList() {

      const url = API_URL + "geographic/NationsList/?active_only=true"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }

      try {

        const response = await axios.get(url, {headers: headers})
        console.debug("response", response.data)

        this.nations_list = response.data.map(nation => ({
          value: nation.id,
          text: nation.nation,
        }))        
        console.debug("nations_list", this.nations_list)
      } 
      catch(error) {
      
        console.log('Failed to load nations list:', error)
      }      
    },
    async loadLocationsList() {

      const url = API_URL + "geographic/LocationsList/"
      const axiosInstance = axios.create({
        headers: {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        },
      })

      try {

        const response = await axiosInstance.get(url)
        this.locations = response.data.map(location => ({
          id: location.id,
          place: location.location,
          nation: location.nation.nation,
          acronym: location.acronym,
        }))
        this.total_rows = this.locations.length
      } 
      catch(error) {
      
        console.log('Failed to load locations list:', error)
      }      
    },
    onPageChange(page) {
      
      this.currentPage = page
      this.$nextTick(() => {
        
        this.loadLocationsList()
      })
    },    
    onPerPageChange(newPerPage) {
    
      this.perPage = newPerPage
      this.currentPage = 1
      this.loadLocationsList()
    },
    onSortChanged(ctx) {
      
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
    },    
    async selectLocation(row) {

      this.current_id = row.id
      const url = API_URL+"geographic/LocationsDetail/"+row.id+"/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.get(url, {headers: headers})
      this.form_data = response.data
    },    
    async updateLocation() {

      const url = API_URL+"geographic/LocationsDetail/"+this.current_id+"/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.patch(url, this.form_data, {headers: headers})
      this.cancelLocation()
      this.loadLocationsList()

    },
  },
}

</script>